import {ScoringModelSchema} from '../market';
import {z} from 'zod';
import {zodTypeguard} from './helpers';
import {ObjectIdSchema} from '../zod';

const ScoringModelRequestSchema = ScoringModelSchema.partial();
export type ScoringModelRequest = z.infer<typeof ScoringModelRequestSchema>;
export const isScoringModelRequest = zodTypeguard(ScoringModelRequestSchema);

export const AccountSimilarityScoreRequestSchema = z.object({
  marketId: ObjectIdSchema,
  accountId: ObjectIdSchema,
});
export type AccountSimilarityScoreRequest = z.infer<
  typeof AccountSimilarityScoreRequestSchema
>;
export const isAccountSimilarityScoreRequest = zodTypeguard(
  AccountSimilarityScoreRequestSchema
);

export const UpdateCreditsRequestSchema = z.object({
  customerId: z.string(),
  amount: z.number(),
  description: z.string().max(100),
});
export type UpdateCreditsRequest = z.infer<typeof UpdateCreditsRequestSchema>;
export const isUpdateCreditsRequest = zodTypeguard(UpdateCreditsRequestSchema);
